package team.platforma.multiplatform_material_extension.tooltips

import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.unit.dp

object TooltipStyle {
    private var _bgColor: Color? = null
    private var _textStyle: TextStyle? = null
    private var _shape: Shape = RoundedCornerShape(100)

    @Composable
    fun define(
        bgColor: Color = MaterialTheme.colorScheme.tertiary,
        textStyle: TextStyle,
        shape: Shape = RoundedCornerShape(6.dp)
    ) {
        _bgColor = bgColor
        _textStyle = textStyle
        _shape = shape
    }

    @Composable
    internal fun getBgColor(): Color {
        return _bgColor ?: MaterialTheme.colorScheme.tertiary
    }

    internal fun getShape(): Shape {
        return _shape
    }

    @Composable
    internal fun getTextStyle(): TextStyle {
        return _textStyle ?: TextStyle()
    }

}